import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SharedModule } from '@shared/shared.module';
import { AuthGuard } from '@app/guards/auth.guard';
import { ProgramHomeComponent } from './program-home.component';
import { ProgramOverviewComponent } from '../program-overview/program-overview.component';
import { EmbedDialogModule } from '@shared/components/embed-dialog/embed-dialog.module';
import { DownloadDialogModule } from '@shared/components/download-dialog/download-dialog.module';
import { CourseEditDialogModule } from '@app/main/apps/course-edit-dialog/course-edit-dialog.module';
import { TemplatePickerDialogModule } from '@shared/components/template-picker-dialog/template-picker-dialog.module';
import { SimulationListComponent } from '../program-overview/simulation-list/simulation-list.component';
import { ProgramReportingModule } from '../program-reporting/program-reporting.module';
import { CurrentContextResolver } from '@app/context-resolver/context-resolver';

// Note that this route is the same as for Spaces.
// This one is only reached if the hub is a program hub because the routes for in WondaModule take priority.
const routes = [
  {
    path: ':urlTitle/:lsId',
    component: ProgramHomeComponent,
    resolve: { context: CurrentContextResolver },
    canActivate: [AuthGuard]
  }
];

@NgModule({
  declarations: [
    ProgramHomeComponent,
    ProgramOverviewComponent,
    SimulationListComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes),
    SharedModule,
    ProgramReportingModule,
    EmbedDialogModule,
    DownloadDialogModule,
    CourseEditDialogModule,
    TemplatePickerDialogModule,
    DragDropModule
  ]
})
export class ProgramHomeModule { }
